import { Redirect, useHistory } from "react-router-dom";
import { TbFlask } from "react-icons/tb";
import { ScreenGreeting } from "../../../../Components/Molecules";
import { PixTransferFinalStep } from "../../../../Components/Molecules/PixTransferSteps/PixTransferFinalStep";
import {
  MOCK_PIX_TRANSFER_BALANCE,
  MOCK_PIX_TRANSFER_RECEIPT,
} from "../../../../Components/Molecules/PixTransferSteps/mockPixTransferReceipt";
import { isDevelopmentOnly } from "../../../../Utils/developmentFeature";

export const PixTransferMockPreview = () => {
  const history = useHistory();

  if (!isDevelopmentOnly) {
    return <Redirect to="/pix/transferencia" />;
  }

  return (
    <div className="pix-transfer-page min-w-0 w-full">
      <div className="pix-transfer-shell">
        <div className="mb-4 flex flex-col gap-2 rounded-xl border border-amber-200/80 bg-amber-50/80 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
          <p className="inline-flex items-start gap-2 text-sm text-amber-950">
            <TbFlask className="mt-0.5 h-4 w-4 shrink-0" />
            Preview de desenvolvimento — dados fictícios, sem movimentar saldo.
          </p>
          <button
            type="button"
            className="btn-outline shrink-0"
            onClick={() => history.push("/pix/transferencia")}
          >
            Ir para fluxo real
          </button>
        </div>

        <ScreenGreeting
          title="Transferência Pix"
          subTitle="Comprovante de transferência finalizada (preview)."
        />

        <PixTransferFinalStep
          transactionStatus
          transactionData={MOCK_PIX_TRANSFER_RECEIPT}
          onNewTransfer={() => history.push("/pix/transferencia")}
          sourceAccountLabel="Conta investimento"
          sourceAccountBalance={MOCK_PIX_TRANSFER_BALANCE}
          sourceAccountBalanceLoading={false}
        />
      </div>
    </div>
  );
};
